import Button from '@/presentation/components/elements/Button';
import SelectPoolForm, {
  SelectPoolFormFields,
} from '@/presentation/components/forms/CreatePositionForms/SelectPoolForm';
import { useForm } from 'react-hook-form';
import type { CreateLiquidityPositionDetails, Step } from '../../types';
import { Address } from 'viem';
import { Dispatch, SetStateAction, useEffect } from 'react';
import {
  getMaxPercentages,
  getMinPercentages,
} from '@/presentation/components/forms/CreatePositionForms/SetRangeForm/utils';

export interface SelectPoolProps {
  feeTier: CreateLiquidityPositionDetails['feeTier'];
  poolType: CreateLiquidityPositionDetails['poolType'];
  using: CreateLiquidityPositionDetails['using'];
  symbol: string;
  collection: Address;
  collectionName: string;
  vaultId?: string;
  icon?: string;
  dispatch: Dispatch<Partial<CreateLiquidityPositionDetails>>;
  onSubmit: (...args: any) => void;
  setStep: Dispatch<SetStateAction<Step>>;
  isNewVault: boolean;
}

export const SelectPool = ({
  feeTier,
  symbol,
  vaultId,
  icon,
  poolType,
  using,
  collection,
  collectionName,
  dispatch,
  onSubmit,
  isNewVault,
}: SelectPoolProps) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    handleSubmit,
    watch,
  } = useForm<SelectPoolFormFields>({
    defaultValues: {
      feeTier,
      poolType,
      using,
    },
  });

  const poolTypeValue = watch('poolType');
  const usingValue = watch('using');

  useEffect(() => {
    dispatch({
      poolType: poolTypeValue,
      using: usingValue,
    });
  }, [poolTypeValue, usingValue, dispatch]);

  const onPoolFormSubmit = handleSubmit(async (values) => {
    dispatch({
      ...values,
    });
    onSubmit();
  });

  return (
    <form onSubmit={onPoolFormSubmit}>
      <SelectPoolForm
        {...{
          feeTier,
          setValue,
          control,
          register,
          errors,
          symbol,
          vaultId,
          icon,
          collection,
          collectionName,
          isNewVault,
        }}
      />
      <Button size="xl" type="submit" className="w-full mt-6">
        {'Next'}
      </Button>
    </form>
  );
};

export default SelectPool;
